import { render, staticRenderFns } from "./Shelve.vue?vue&type=template&id=0baf8e30&scoped=true&"
import script from "./Shelve.vue?vue&type=script&lang=js&"
export * from "./Shelve.vue?vue&type=script&lang=js&"
import style0 from "./Shelve.vue?vue&type=style&index=0&id=0baf8e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf8e30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
